import { GEOMETRY_TYPES } from 'g3w-constants';

/**
 * core/geometry/geometry::isLineGeometryType@v3.4
 * core/geometry/geometry::getAllLineGeometryTypes@v3.4
 */
export function isLineGeometryType(geometryType) {
  return [
    GEOMETRY_TYPES.LINESTRING,
    GEOMETRY_TYPES.LINESTRINGZ,
    GEOMETRY_TYPES.LINESTRINGM,
    GEOMETRY_TYPES.LINESTRINGZM,
    GEOMETRY_TYPES.LINESTRING25D,
    GEOMETRY_TYPES.MULTILINESTRING,
    GEOMETRY_TYPES.MULTILINESTRINGZ,
    GEOMETRY_TYPES.MULTILINESTRINGM,
    GEOMETRY_TYPES.MULTILINESTRINGZM,
    GEOMETRY_TYPES.MULTILINESTRING25D,
    GEOMETRY_TYPES.LINE,
    GEOMETRY_TYPES.LINEZ,
    GEOMETRY_TYPES.LINEM,
    GEOMETRY_TYPES.LINEZM,
    GEOMETRY_TYPES.LINE25D,
    GEOMETRY_TYPES.MULTILINE,
    GEOMETRY_TYPES.MULTILINEZ,
    GEOMETRY_TYPES.MULTILINEM,
    GEOMETRY_TYPES.MULTILINEZM,
    GEOMETRY_TYPES.MULTILINE25D,
  ].includes(geometryType);
}